"use client";

import dynamic from "next/dynamic";
import PropTypes from "prop-types";

const Header = dynamic(() => import("../../components/organisms/header"));

/**
 * Client component wrapper for the not-found Header.
 *
 * The mega menu is not fetched here — `<Header>` loads it client-side on desktop, so
 * duplicating that request would only add a second call for the same payload.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isMobile - Whether the request is from mobile device
 * @returns {JSX.Element} The Header component
 */
const NotFoundHeader = ({ isMobile }) => {
  return <Header isMobile={isMobile} isShowSearchIcon={false} />;
};

NotFoundHeader.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default NotFoundHeader;
